import clsx from 'clsx';
import React from 'react';

type BadgeVariant = 'primary';

type BadgeSize = 'default' | 'sm';

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'primary',
  size = 'default',
  className,
  ...props
}) => {
  const badgeVariants = clsx(
    'inline-flex items-center rounded-full font-medium',
    {
      [`bg-primary/20 text-primary`]: variant === 'primary',
      [`gap-x-1.5 py-1.5 px-3 text-xs`]: size === 'default',
      [`gap-x-1 py-1 px-1.5 text-[10px]`]: size === 'sm',
    },
  );
  const combinedClasses = `${badgeVariants} ${className}`;

  return <span {...props} className={combinedClasses}></span>;
};
Badge.displayName = 'Badge';

export { Badge };
